import { render, staticRenderFns } from "./EntradaFormComponent.vue?vue&type=template&id=189c249d"
import script from "./EntradaFormComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./EntradaFormComponent.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports